import "../css/main.css";
import { decorateH1Headlines } from "./components/h1-headline";
import { handleSearch } from "./components/search";
import { handleNavigation } from "./partials/navigation";
import { handleRoleButtons } from "./utils";
import { updateScrollOffset } from "./utils";
import { initUsercentricsReload, initUsercentricsAcceptButtons } from "./utils/usercentrics-handler";
import { initShortcodeAccordions } from "./components/shortcode-accordion";
import { initFormSuccess } from "./components/form-success";

window.addEventListener("load", () => {
  handleRoleButtons();
  handleNavigation();
  updateScrollOffset();
  handleSearch();
  decorateH1Headlines();
  initUsercentricsReload();
  initUsercentricsAcceptButtons();
  initShortcodeAccordions();
  initFormSuccess();
});

window.addEventListener("resize", updateScrollOffset)
